import { Stack } from '@optimus-web/core';
import { ResourceCategoryNameByResource, ResourceStateTag } from '../../../../components/commander-ui';
import { ResourceName } from '../../../../components/reservation/ResourceName';

interface Props {
    resourceId: string;
    serviceId: string;
}

const AssignedResoureLabel = ({ resourceId, serviceId }: Props) => (
    <Stack spacing="100">
        <span>
            <ResourceCategoryNameByResource resourceId={resourceId} serviceId={serviceId} short />
        </span>
        <ResourceName resourceId={resourceId} />
        <ResourceStateTag resourceId={resourceId} />
    </Stack>
);

export default AssignedResoureLabel;
